import Vue from 'vue'
import Vuex from 'vuex'
import Api from './modules/Api'
import SessionService from './modules/SessionService'
import Configuration from './modules/Configuration'
import Pages from './modules/Pages'
import Snippets from './modules/Snippets'
import Emails from './modules/Emails'
// import Page from './modules/Page'
import Snippet from './modules/Snippet'
import Translations from './modules/Translations'
import Currencies from './modules/Currencies'
import EditorSettings from './modules/EditorSettings'
import FileBrowser from './modules/FileBrowser'
import Toast from './modules/Toast'
import Modal from './modules/Modal'
import Import from './modules/Import'
import Export from './modules/Export'
import UserState from './modules/UserState'
import AITranslations from './modules/AITranslations'

Vue.use(Vuex)

export default new Vuex.Store({
	namespaced: true,
	mutations: {
		SET_COOKIE ({}, payload) {
			let newCookie = payload.name + '=' + payload.value
			if (payload.expireTime) {
				newCookie += '; max-age=' + payload.expireTime // set expire date
			}
			if (payload.path) {
				newCookie += '; Path=' + payload.path
			} else {
				newCookie += '; Path=/'
			}
			document.cookie = newCookie
		},
		CLEAR_ALL_COOKIES () {
			document.cookie.split(';').forEach((cookie) => {
				const key = cookie.split('=')
				document.cookie = key[0] + ' =;  Path=/; expires = Thu, 01 Jan 1970 00:00:00 UTC'
			})
		}
	},
	getters: {
		getCookie ({}, name) {
			// returns a function so it can be called with params
			return (name) => {
				return document.cookie.length > 0 && document.cookie.includes(name + '=') ? document.cookie.split(name + '=')[1].split(';')[0] : false // get cookie value
			}
		}
	},
	modules: {
		Api,
		SessionService,
		Configuration,
		Pages,
		Snippets,
		Emails,
		// Page,
		Snippet,
		Translations,
		Currencies,
		EditorSettings,
		FileBrowser,
		Toast,
		UserState,
		Modal,
		Import,
		Export,
		AITranslations
	}
})
